import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import {
  Divider, Grid, Typography, Container,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { numbers } from '@annexus/utils';
import { scrollVertically } from '../../utils';
import { ESTIMATED_BENEFITS, POTENTIAL_REDUCTION_ESTIMATED } from '../../constants';

const EstimatedSocialSecurityBenefits = ({
  potentialReduction, lifetimeReduction, benefitEstimator, monthlyReduction,
}) => {
  const largeScreen = useMediaQuery((theme) => theme.breakpoints.up('tabletportrait'));
  scrollVertically(0, 250);
  return (
    <Grid component={Container} container mb={largeScreen ? 9 : 4} className='estimated-benefits-container' justifyContent={largeScreen ? 'center' : 'flex-start'}>
      <Typography variant='page-title' component='h1' className='title'>
        Your estimated Social
        <span className='no-wrap-text'>
          {' '}
          Security benefit
        </span>
      </Typography>
      <Grid container item xs={12} sm={10} className='estimated-benefits-result-container' justifyContent='space-between'>
        <Grid item customtablet={4} xs={12} sx={{ mb: { xs: 3, tabletportrait: 0 } }}>
          <Typography className='benefit-label'>{ESTIMATED_BENEFITS.POTENTIAL}</Typography>
          <span className='benefit-number'>
            {potentialReduction > 0 && '-'}
            {numbers.getPercentFormat(potentialReduction)}
          </span>
        </Grid>
        <Grid item customtablet={4} xs={12} sx={{ mb: { xs: 3, tabletportrait: 0 } }}>
          <Typography className='benefit-label'>{ESTIMATED_BENEFITS.MONTHLY}</Typography>
          <span className='benefit-number'>
            {monthlyReduction > 0 && '-'}
            {numbers.getCurrencyFormat(monthlyReduction)}
          </span>
        </Grid>
        <Grid item customtablet={4} xs={12} sx={{ mb: { xs: 3, tabletportrait: 0 } }}>
          <Typography className='benefit-label'>{ESTIMATED_BENEFITS.LIFETIME}</Typography>
          <span className='benefit-number no-wrap-text'>
            {lifetimeReduction > 0 && '-'}
            {numbers.getCurrencyFormat(lifetimeReduction)}
          </span>
        </Grid>
        <Divider className='benefits-divider' />
        <Grid item xs={12} sx={{ mb: { xs: 3, tabletportrait: 0 } }}>
          <Typography variant='body2' className='benefits-footnote'>
            Based on the Social Security benefit information you provided and the estimated reduction of scheduled benefits of
            {' '}
            {benefitEstimator?.benefitEstimator?.potentialReductionEstimated < POTENTIAL_REDUCTION_ESTIMATED.MAX
              ? `${benefitEstimator?.benefitEstimator?.potentialReductionEstimated}% you entered` : `${numbers.getPercentFormat(potentialReduction)} in 2033`}
            , you have a projected potential reduction of your lifetime Social Security benefits
            <span className='no-wrap-text'>
              {` of ${numbers.getCurrencyFormat(lifetimeReduction)}.`}
            </span>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

EstimatedSocialSecurityBenefits.propTypes = {
  potentialReduction: PropTypes.number,
  lifetimeReduction: PropTypes.number,
  benefitEstimator: PropTypes.shape(),
  monthlyReduction: PropTypes.number,
};

EstimatedSocialSecurityBenefits.defaultProps = {
  potentialReduction: 0,
  lifetimeReduction: 0,
  benefitEstimator: undefined,
  monthlyReduction: 0,
};

export default EstimatedSocialSecurityBenefits;
